import { createFileRoute } from "@tanstack/react-router";
import { aeoGeo } from "@/lib/seo/schema";

export const Route = createFileRoute("/integritet")({
  head: () => ({
    meta: [
      { title: "Integritetspolicy — så hanterar vi era uppgifter" },
      { name: "description", content: "Hur Fenny hanterar cookies, analytics, formulärdata och personuppgifter — enligt GDPR och svensk lag. Kontakta oss för registerutdrag eller invändningar." },
    ],
    links: [{ rel: "canonical", href: "https://fenny.se/integritet" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(aeoGeo({path: "/integritet", name: "Integritetspolicy — Fenny", description: "Hur Fenny hanterar cookies, analytics, formulärdata och personuppgifter — enligt GDPR och svensk lag. Kontakta oss för registerutdrag eller invändningar."})) },
    ],
  }),

  component: Privacy,
});

function Privacy() {
  return (
    <article className="mx-auto max-w-3xl px-4 py-16 prose prose-invert">
      <h1>Integritet & cookies</h1>
      <p>
        Vi använder en egen, anonym first-party analytics-lösning för att förstå hur sajten används.
        Inga cookies eller spårnings-ID sätts innan du aktivt accepterat det via vår cookie-banner.
      </p>
      <h2>Vad vi samlar in (vid samtycke)</h2>
      <ul>
        <li>Anonymt besökar-ID och sessions-ID (lagras lokalt i din webbläsare)</li>
        <li>Sidvisningar, källa (referrer), UTM-parametrar</li>
        <li>Enhetstyp, browser, OS, språk, land (via IP — IP lagras inte)</li>
      </ul>
      <h2>Vad vi <em>inte</em> gör</h2>
      <ul>
        <li>Vi lagrar aldrig din IP-adress i klartext</li>
        <li>Vi delar inte data med tredje part för annonsering</li>
        <li>Vi använder ingen cross-site-tracking</li>
      </ul>
      <h2>Formulär & e-post</h2>
      <p>
        När du skickar in ett formulär sparar vi dina kontaktuppgifter för att kunna återkomma till dig.
        Bekräftelse- och interna notisutskick loggas för att kunna felsöka leveransproblem.
      </p>
      <h2>Dina rättigheter</h2>
      <p>
        Mejla <a href="mailto:hey@fenny.se">hey@fenny.se</a> för att begära utdrag, rättelse eller
        radering av dina uppgifter.
      </p>
    </article>
  );
}
